enum Features {
  Compliments = 'compliments',
  Incognito_mode = 'incognito-mode',
  Snooze_mode = 'snooze-mode',
  Superswipe = 'superswipe',
  Travel_mode = 'travel-mode',
  Video_chat = 'video-chat',
  Instant_match = 'instant-match',
  Discover = 'discover',
}

const rootFeatureRouteFolder = '/features/';
const langFeatureRouteFolder = '/[lang]/features/';

enum FeatureRoutes {
  Compliments = rootFeatureRouteFolder + Features.Compliments,
  Incognito_mode = rootFeatureRouteFolder + Features.Incognito_mode,
  Snooze_mode = rootFeatureRouteFolder + Features.Snooze_mode,
  Superswipe = rootFeatureRouteFolder + Features.Superswipe,
  Travel_mode = rootFeatureRouteFolder + Features.Travel_mode,
  Instant_match = rootFeatureRouteFolder + Features.Instant_match,
  Discover = rootFeatureRouteFolder + Features.Discover,
  Video_chat = rootFeatureRouteFolder + Features.Video_chat,
  LocalisedCompliments = langFeatureRouteFolder + Features.Compliments,
  LocalisedIncognito_mode = langFeatureRouteFolder + Features.Incognito_mode,
  LocalisedSnooze_mode = langFeatureRouteFolder + Features.Snooze_mode,
  LocalisedSuperswipe = langFeatureRouteFolder + Features.Superswipe,
  LocalisedTravel_mode = langFeatureRouteFolder + Features.Travel_mode,
  LocalisedVideo_chat = langFeatureRouteFolder + Features.Video_chat,
  LocalisedInstantMatch = langFeatureRouteFolder + Features.Instant_match,
  LocalisedDiscover = langFeatureRouteFolder + Features.Discover,
}

export { Features, FeatureRoutes };

const FEATURE_COMPLIMENTS_AMOUNT_NUM = 3;
const FEATURE_SUPERSWIPE_AMOUNT_NUM = 10;

export { FEATURE_COMPLIMENTS_AMOUNT_NUM, FEATURE_SUPERSWIPE_AMOUNT_NUM };
